import Grid from '@mui/material/Grid';
import { forwardRef } from 'react';

import DesktopProductCard from './Desktop';
import MobileProductCard from './Mobile';

const ReviewProductCard = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  return (
    <Grid container ref={ref}>
      <Grid
        container
        sx={theme => ({
          [theme.breakpoints.down('md')]: { display: 'none' },
        })}
        data-testid="review-product-card-desktop-container"
        display="block"
      >
        <DesktopProductCard />
      </Grid>
      <Grid
        container
        sx={theme => ({
          [theme.breakpoints.up('md')]: { display: 'none' },
        })}
        data-testid="review-product-card-mobile-container"
      >
        <MobileProductCard />
      </Grid>
    </Grid>
  );
});

export default ReviewProductCard;
